import { useState } from 'react';
import { Upload, Button, message } from 'antd';
import upload from '../img/upload.svg'
import { useTranslation } from "react-i18next";

function AdvancedUpload({onSendUrl}) {
  const { t, i18n }: { t: any,i18n:any } = useTranslation();
  const [fileList, setFileList] = useState([]);

  const props = {
    action: 'http://38.165.46.98:8085/token-use-api/api/token/loadPhoto',
    multiple: true,
    fileList,
    beforeUpload: (file) => {
      const isImage = file.type.startsWith('image/');
      // 验证文件类型
      const isPNG = file.type === 'image/png' || file.name.endsWith('.png');
     // 验证文件大小（300KB = 300 * 1024 = 307200 字节）
      const isLt300K = file.size / 1024 <= 300;
      if (!isPNG) {
        message.error('只能上传 PNG 格式的图片!');
        return Upload.LIST_IGNORE; // 阻止上传并隐藏文件
      }
      if (!isLt300K) {
        message.error('图片大小不能超过 300KB!');
        return Upload.LIST_IGNORE;
      }
      if (!isImage) {
        message.error('只能上传图片文件！');
      }
      return isImage;
    },
    onChange: ({ file, fileList }) => {
      if (file.status === 'done') {
        message.success(`${file.name} 上传成功`);
        onSendUrl(`https://awsadverimages.s3.ap-east-1.amazonaws.com/HiLwlGhpgxINjTmEKMk2u/m6SXYEiDzxwB1/iK9M/tokeninfo/${file.name}`)
      } else if (file.status === 'error') {
        message.error(`${file.name} 上传失败`);
      }
      setFileList(fileList);
    },
    onRemove: (file) => {
      setFileList(fileList.filter(f => f.uid !== file.uid));
    },
    headers: {
      authorization: 'your-auth-token', // 如果需要认证头
    },
    data: {
      appKey: '3269830f92740058b8b32a1f863b37581a5cc1fe421d68c7fcc5a36358d89a63', // 附加参数
    },
    showUploadList: {
      showDownloadIcon: true,
      downloadIcon: '下载',
      showRemoveIcon: true,
    }
    };
    // 限制文件大小为2MB
    const beforeUpload = (file) => {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('文件大小不能超过2MB!');
        }
        return isLt2M;
    };

  return (
    <Upload {...props}>
        <img src={upload} style={{ width:32,height:32,color:'#fff'}}/><br />
        <span style={{ color: '#fff' }}>{t('It20')}</span><br />
        <span style={{ color: '#fff' }}><span style={{ color: '#23D8F0' }}>{t('It21')}</span></span>
    </Upload>
  );
}
export default AdvancedUpload